exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1b565d2e] .el-loading-spinner {\n  transform: translateY(-50%);\n}\n", ""]);

// exports
